import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12ad2bf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "find-contacts-container" }
const _hoisted_2 = {
  key: 1,
  class: "no-results"
}

import { computed, PropType, ref } from "vue";
import GridBase from "@/components/ui/grid/grid-base.vue";
import { DxColumn } from "devextreme-vue/data-grid";
import { AddressLookupResult } from "@/types/address-lookup/AddressLookupResult";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";


export default /*#__PURE__*/_defineComponent({
  __name: 'find-postcode-modal',
  props: {
  /**
   * An array of address lookup results.
   * @type {AddressLookupResult[]}
   */
  data: {
    type: Array as PropType<AddressLookupResult[]>,
  },

  /**
   * Indicates whether a search operation is currently in progress.
   * @type {boolean}
   * @default false
   */
  searching: {
    type: Boolean,
    default: false,
  },

  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @default false
   */
  modelValue: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue", "rowClick", "postcodeSelected"],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const postcodeSelected = ref<AddressLookupResult>();

/** Handles the grid row click event */
const onRowClick = (e: AddressLookupResult) => emit("rowClick", e);

/** Handles the grid row selected event */
const onRowSelected = (e: AddressLookupResult) => {
  if (e) {
    postcodeSelected.value = e;
  }
};

// Handles the event triggered when the user clicks on the ... button on a row
const adaptiveRowSelection = (e: AddressLookupResult) => {
  if (e) {
    postcodeSelected.value = e;
  }
};

const onSelectClick = () => {
  emitSelectedProperty();
};

const closeModal = () => {
  showModal.value = false;
};

const emitSelectedProperty = () => {
  showModal.value = false;
  emit("postcodeSelected", postcodeSelected.value);
};

/** Determines whether any address results have been found */
const addressResultsFound = computed(() => {
  if (!props.data) {
    return false;
  }

  /* Sometimes the api can return an array with 1 item but no details
   * To prevent a DevExpress error, we need to ensure the display address is set for every record
   * blank display addresses are allowed as this doesn't cause an error */
  return props.data.every((item) => item.displayAddress != null);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    title: "Find Address",
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event)),
    height: "80vh"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (addressResultsFound.value)
          ? (_openBlock(), _createBlock(GridBase, {
              key: 0,
              "data-source": __props.data,
              loading: __props.searching,
              "show-column-filters": false,
              "id-column-name": "displayAddress",
              onRowClick: onRowClick,
              onRowSelected: onRowSelected,
              onAdaptiveRowSelection: adaptiveRowSelection
            }, {
              columns: _withCtx(() => [
                _createVNode(_unref(DxColumn), {
                  "data-field": "displayAddress",
                  caption: "Address"
                })
              ]),
              _: 1
            }, 8, ["data-source", "loading"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, " No results found"))
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Select',
          disabled: !postcodeSelected.value,
          onClick: () => onSelectClick(),
        }
      }, null, 8, ["options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: { text: 'Close', onClick: () => closeModal() }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})